import React from "react"
import Instagram from "../components/svg/socials/instagram"
import Facebook from "../components/svg/socials/facebook"
import Fbmessenger from "../components/svg/socials/fbmessenger"
import Youtube from "../components/svg/socials/youtube"

export const socialsArray = [
  {
    tag: <Instagram />,
    link: "https://www.instagram.com/langue.croix/?fbclid=IwAR0apvICMDSX0YU9q0X07k0--aLY4Sn2mLYmHQQ5HCZzO3V8a8kPE0QmjTA",
    key: "in"
  },
  {
    tag: <Youtube />,
    link: "https://www.youtube.com/channel/UCx55oejslOa49cmVMQ29v_Q",
    key: "yt"
  },
  {
    tag: <Fbmessenger />,
    link: "http://m.me/L.ecole.des.langues.A.Croix",
    key: "fm"
  },
  {
    tag: <Facebook />,
    link: "https://www.facebook.com/L.ecole.des.langues.A.Croix",
    key: "fb"
  }
]
